export default function(array) {
  const timetableController = global.timetableController

  if (!timetableController) return

  if (timetableController.hideNonWorkingBarbers) return timetableController.setState({}, { advance: false })

  timetableController.reload()
}
